import React from "react";
import Progressbar from "react-js-progressbar";
import Styled from "styled-components";
function MySkills() {
  const skills = {
    java: 50,
    html: 70,
    css: 70,
    python: 60,
    reactjs: 50,
    javascript: 50,
  };
  return (
    <MainCont>
      <Heading>My Skills</Heading>
      <SkillCont style={{ flexWrap: "wrap" }}>
        {Object.entries(skills).map(([skill, percentage], i) => (
          <SkillProgress>
            <Progressbar
              input={percentage}
              pathWidth={20}
              pathColor={"#ffb400"}
              trailWidth={20}
              trailColor="#323232"
              textStyle={{ fill: "white" }}
            />
            <Caption>{skill}</Caption>
          </SkillProgress>
        ))}
      </SkillCont>
    </MainCont>
  );
}
const SkillProgress = Styled.div`
    width:125px;
    height:125px;
    margin:2rem;
    margin-top:4rem;
`;
const SkillCont = Styled.div`
    display:flex;
    flex-wrap:wrap;
    gap:calc(100%/6);
    justify-content:center;
    align-items:center;
    `;

const Heading = Styled.span`
    color:white;
    font-size:30px;
    font-family:sans-serif;
    font-weight:550;
    letter-spacing:1px;
    display:block;
    text-align:center;
    margin-bottom:3rem;
    text-transform:capitalize;
    @media (max-width:425px){
      font-size:25px;
    }
    `;
const Caption = Styled.h2`
    color:white;
    text-align:center;
    text-transform:uppercase;
`;
const MainCont = Styled.div`
    margin-bottom:5vh;
`;
export default MySkills;
